import React, { HTMLAttributes } from 'react';

export const MarkdownOrderedList: React.FC<HTMLAttributes<HTMLOListElement>> = ({ children }) => {
  return <ol className={'list-inside list-decimal whitespace-normal'}>{children}</ol>;
};
